const map: any = {
"655360":"应用或登录方式不存在",
"655361":"无法获取应用的信息",
"655362":"无法获取登录方式配置信息",
"655363":"验证用户时发生错误",
"655364":"验证用户时发生未知错误",
"655365":"无法生成令牌",
"655366":"未找到认证方式",
"655367":"无法解析Code",
"655368":"错误解析连接配置",
"655369":"第三方登录失败",
"655370":"第三方结果解析失败",
"655371":"用户名或密码错误",
"655372":"用户没找到或密码不匹配",
"655373":"登录方式不允许",
"655374":"验证码不匹配",
"655375":"无效令牌，解密令牌错误",
"655376":"无效的MFA挑战程序",
"655377":"无效的MFA处理程序",
"655378":"无效的凭证",
"655379":"无效的令牌, 找不到令牌",
"655380":"无效的令牌, 令牌过期",
"655381":"无效的令牌，令牌无效",
"655382":"重置密码令牌过期",
"655383":"租户政策检查失败",
"655384":"用户已锁定，密码失败次数过多",
"655385":"用户创建失败",
"655386":"保存令牌失败",
"655387":"发送MFA绑定请求失败，无法得到待验证的用户信息",
"655388":"发送MFA绑定请求失败，该手机号已存在",
"655389":"发送MFA手机绑定请求失败",
"655390":"发送MFA绑定请求失败，该邮箱已存在",
"655391":"发送MFA邮箱绑定请求失败",
"655392":"发送MFA请求失败，无法得到待验证的用户信息",
"655393":"发送手机短信MFA挑战失败",
"655394":"发送电子邮件MFA挑战失败",
"655395":"MFA绑定失败，无法在当前会话中获得用户信息",
"655396":"MFA绑定失败，无效的手机或验证码",
"655397":"MFA绑定失败，无法得到验证码",
"655398":"MFA绑定失败，删除过期验证码失败",
"655399":"MFA绑定失败，验证码错误",
"655400":"MFA绑定失败，更新用户手机失败",
"655401":"MFA绑定失败，无效的邮件或验证码",
"655402":"MFA绑定失败，更新用户的邮箱失败",
"655403":"MFA验证失败，无法得到待验证的用户信息",
"655404":"MFA失败，验证码不匹配",
"655405":"发送重置密码挑战失败",
"655406":"重置密码失败，无效的操作",
"655407":"重置密码失败，您在不安全的环境中执行操作",
"655408":"重置密码失败",
"655409":"重置密码失败，无效的验证码",
"655410":"重置密码失败，刷新令牌状态失败",
"655411":"重置密码失败，操作不支持",
"655412":"从IDP获取用户信息失败",
"655413":"从IDP获取用户访问令牌失败",
"655414":"从IDP获取用户open_id失败",
"655415":"未找到可用的验证方式，用户未预留手机号或者邮箱",
"655416":"MFA绑定失败，OTP用户已存在",
"655417":"MFA绑定失败，OTP创建失败",
"655418":"发送验证信息失败，用户信息不存在",
"655419":"MFA验证方式不一致",
"655420":"不是一个RAM登录账号",
"655421":"信任方式登录失败，解密令牌失败",
"655433":"系统当前禁止该用户登录",
"655434":"您本次登录需要验证码",
"655435":"您输入的验证码有误，无法登录",
"8193":"无效的短信提供商",
"8194":"发送短信失败",
"8195":"短信参数错误",
"8196":"不符合密码策略规则",
"8197":"密钥生成失败",
"8198":"密钥生成错误，不支持的算法",
"8199":"更新租户信息错误，无法获取原租户信息",
"8200":"更新租户信息错误，无效的域名",
"8201":"更新自定义字段失败，无法获取原始定义",
"8202":"无法更新该记录",
"8203":"密码过于简单",
"8204":"保存失败",
"8205":"无法得到字典条目",
"8206":"无法得到IDP信息",
"8207":"无法得到自定义字段的定义",
"8208":"无法得到该租户的信息",
"8209":"无法删除该租户",
"8210":"无法保存该租户",
"8211":"无法创建租户，重复的租户名",
"8212":"无法保存开发者信息，验证码无效",
"8213":"无法创建字典条目，键或值为空",
"8214":"删除IDP失败",
"8215":"无法生成KWT令牌",
"8216":"无法生成kid（密钥ID）",
"8217":"无法生成密钥",
"8218":"不能检查JWT令牌",
"8219":"无法获得JWT令牌",
"8220":"JWT令牌已过期",
"8221":"验证码无效",
"8222":"无法找到令牌",
"8223":"获得验证方式配置失败",
"8224":"创建认证方法配置失败",
"8225":"保存认证方法配置失败",
"8226":"删除认证方法配置失败",
"8227":"创建认证方法失败、",
"8228":"保存/更新认证方法失败",
"8229":"检索认证方法失败",
"8230":"创建IDP配置失败",
"8231":"保存IDP配置失败",
"8232":"得到IDP配置失败",
"8233":"得到IDP失败",
"8234":"发送通知时发生错误",
"8235":"保存租户策略失败",
"8236":"得到租户策略失败",
"8237":"密码检查失败",
"8238":"开发者验证信息已经存在",
"8239":"处理租户创建失败",
"8240":"保存租户日志失败",
"8241":"获取租户日志失败",
"8242":"获取租户密钥失败",
"8243":"获取租户Logo失败",
"8244":"发布租户Logo失败",
"8245":"保存开发者时，更新信息失败",
"8246":"发送电子邮件失败",
"8247":"开发者验证真实姓名失败",
"8248":"用户权限错误",
"8249":"无效的用户信息或空的X-Payload",
"8250":"无效的参数",
"8251":"签署用户信息失败",
"8252":"无效的认证方法配置ID",
"8253":"无效的认证方法配置请求",
"8254":"保存字典表条目失败，无效的'范围'",
"8255":"保存字典表条目失败",
"8256":"保存字典表条目失败，请求无效",
"8257":"更新字典表条目失败，无效的'范围'",
"8258":"获取字典表条目失败，无效的键值",
"8259":"获取字典表条目失败，无效的分类",
"8260":"保存租户策略失败，无效的ID",
"8261":"获得IDP失败，CID无效",
"8262":"获得自定义字段的定义无效，实体类型无效",
"8263":"删除自定义字段的定义无效，无效的ID",
"8264":"删除自定义字段的定义无效，无效的SID",
"8265":"获取自定义字段的定义无效，无效的ID",
"8266":"获取租户失败，无效的ID",
"8267":"无效的IDP配置请求",
"8268":"IDP配置失败，无效的ID",
"8269":"错误的租户请求",
"8270":"删除租户失败，无效的ID",
"8271":"错误的开发者请求",
"8272":"删除IDP配置失败，无效的ID",
"8273":"获取开发者失败，无效的ID",
"8274":"获取开发者失败，无效的UID",
"8275":"获取开发者验证信息失败，无效的ID",
"8276":"获取开发者验证信息失败，无效的开发者ID",
"8277":"生成开发者令牌时发生错误",
"8278":"生成开发者令牌时发生错误，无效ID",
"8279":"生成开发者令牌时发生错误，无效请求",
"8280":"常见参数错误",
"8281":"生成KMS记录失败，无效请求",
"8282":"无效的密钥ID",
"8283":"获得KMS记录失败",
"8284":"开发者实名认证失败",
"8285":"保存自定义字段的定义失败，无效ID",
"8286":"保存自定义字段的定义失败，无效请求",
"8287":"保存租户失败，无效的ID",
"8288":"删除AMC失败，无法检索到原AMC",
"8289":"删除AMC失败，租户访问违规",
"8290":"删除IDP失败，租户访问违规",
"8291":"获取AMC失败，租户访问违规",
"8292":"获取IDP失败，租户访问违规",
"8293":"获取IDP配置失败，删除密钥失败",
"8294":"验证码失败，无效的类型",
"8295":"保存自定义字段的定义失败、",
"8296":"保存开发者失败",
"8297":"保存开发者验证失败",
"8298":"存取字典表条目失败",
"8299":"获取字典表条目失败，拒绝访问",
"8300":"删除租户数据失败",
"8301":"删除自定义字段的定义失败",
"8302":"获取开发者失败",
"8303":"获取开发者验证信息失败",
"8304":"短信发送失败, 配置错误",
"8305":"检查租户策略失败，未知的场景",
"8306":"检查密码失败，解析请求失败",
"8307":"检查密码失败，未找到租户",
"8308":"检查密码失败，违反密码规则",
"8309":"检查密码失败，密码长度不足",
"8310":"检查密码失败，违反密码安全规则",
"8311":"检查密码失败，密码在黑名单中",
"8312":"检查密码失败，密码在历史密码中",
"8313":"修改开发者密码失败",
"8314":"修改开发者密码失败, 无效的请求",
"8315":"测试 LDAP 连接失败",
"8316":"检查身份失败",
"8317":"更新开发者状态失败",
"8318":"上传文件失败",
"8319":"获取文件失败",
"8320":"创建公共字典失败",
"8321":"更新公共字典失败",
"8322":"删除公共字典失败",
"8323":"获取字典失败，项目为空",
"8324":"保存分级授权用户失败",
"8325":"获取分级授权用户失败",
"8326":"删除分级授权用户失败",
"8327":"发送邮件失败，频率限制",
"8328":"获取黑名单失败",
"8329":"刷新黑名单失败",
"8330":"刷新黑名单失败，超过上限数量",
"16842752":"通用错误",
"16842753":"认证失败",
"16842754":"应用程序访问被拒绝",
"16842755":"无效的MFA请求",
"16842756":"MFA失败",
"16842757":"无效的认证请求",
"16842758":"无效令牌或生成令牌失败",
"16842759":"令牌过期",
"16842760":"无效的令牌",
"16842761":"刷新令牌失败",
"16842762":"密码重置失败",
"16842763":"函数执行失败（在认证之前）",
"16842764":"函数执行失败(认证后)",
"16842765":"函数执行失败（注册前）",
"16842766":"函数执行失败（注册后）",
"16842767":"错误的注册请求",
"16842768":"错误的注册请求，验证码不匹配",
"16842769":"签约失败",
"16842770":"启动应用程序失败，未找到应用程序",
"16842771":"启动租户信息失败",
"16842772":"获取协议配置失败，无法找到协议",
"16842773":"获取协议配置失败，协议配置为空",
"16842774":"在检索开发者令牌时，无效的应用程序信息",
"16842775":"在检索开发者令牌时无效的ID令牌",
"16842776":"无效的开发者令牌",
"16842777":"无效的控制台地址",
"16842778":"用户授权被拒绝",
"16842779":"该手机号已注册，请直接登录",
"16842780":"该邮箱已注册，请直接登录",
"16842781":"执行MFA前函数编排失败",
"16842782":"执行MFA后函数编排失败",
"16842783":"获得应用公开信息失败",
"16842784":"获得用户信息失败",
"16842785":"执行MFA绑定前函数编排失败",
"16842786":"用户自动绑定失败",
"16842787":"在当前身份源下创建用户失败",
"16842788":"用户手动绑定失败",
"16842789":"创建用户失败",
"16842790":"自动创建用户失败",
"16842791":"获取高级密码策略失败",
"16842792":"获得人机验证信息失败",
"16842793":"验证人机验证信息失败",
"16842794":"重定向人机验证失败",
"131072":"用户名已存在",
"131073":"手机号已存在",
"131074":"邮箱已存在",
"131075":"ids 长度限制 1 到 1000",
"131076":"无效的参数，原始密码为空",
"131077":"无效的参数，新密码为空",
"131078":"无效的参数，原始密码错误",
"131079":"登录名不存在",
"131080":"无效的用户扩展属性",
"131081":"无法获取租户安全策略",
"131082":"用户社会化已注册",
"131083":"用户已禁用",
"131084":"无效的身份源ID",
"720896":"",
"417793":"flow执行超时，终止flow",
"417794":"flow执行错误，终止flow",
"417795":"function查询错误",
"417797":"数据库更新失败",
"417798":"调用远程失败",
"421889":"",
"327732":"当前用户已属相斥节点",
"327733":"远程服务握手失败",
"327734":"远程服务返回失败",
"327735":"用户不存在",
"327736":"获取snowId失败",
"327737":"触发唯一键约束",
"327744":"创建数据失败",
"327745":"更新数据失败",
"327746":"查询数据失败",
"327747":"删除数据失败",
"327748":"数据不完整",
"327749":"数据库数据错误",
"327750":"根节点已存在",
"327751":"目标节点不存在",
"327752":"节点不为空",
"327753":"解析远程数据失败",
"327760":"远程数据绑定失败",
"327761":"object_code不能为空",
"327762":"无效的参数: is_default",
"327763":"无效的路径参数: id",
"327764":"sys_code不能为空",
"327765":"code不能为空",
"327766":"is_pointer不能为空",
"327767":"name不能为空",
"327768":"无效的路径参数: user_id",
"327769":"ids不能为空",
"327776":"scene_code不能为空",
"327779":"scope不能为空",
"327780":"calc不能为空",
"327781":"user_ids不能为空",
"327782":"关联关系不完整",
"327783":"source_node_id和dest_node_id不能同时为空",
"327784":"id和ids不能同时为空",
"327785":"user_id不能为空",
"327792":"node_id不能为空",
"327793":"tree_code不能为空",
"327794":"scene_code、tree_code和node_id不能同时为空",
"327795":"无效的参数: mode",
"393217":"events不能为空",
"393218":"name不能为空",
"393219":"callback_url不能为空",
"393220":"req_format不能为空",
"393221":"req_format必须为json或form",
"393222":"req_param不能为空",
"393223":"id不能为空",
"393224":"flow_id不能为空",
"393225":"timeout不合法",
"393232":"order_origin参数不合法",
"393233":"order_dest参数不合法",
"393234":"order_origin和order_dest应为同样的大小",
"393235":"template_ids不能为空",
"393236":"stage不能为空",
"393237":"version不能为空",
"393238":"runtime不能为空",
"393239":"template不能为空",
"393240":"id/stage/version/runtime不能全为空",
"393241":"ttl不合法",
"393248":"ids不能为空",
"393249":"一次删除不能超过1000个",
"393250":"获取snowId失败",
"393251":"创建function失败",
"393252":"更新function失败",
"393253":"查询数据失败",
"393254":"触发唯一键约束",
"393255":"删除function失败",
"393256":"删除非空资源",
"393257":"开启的Function数量超过限制",
"393264":"function已经开启",
"393265":"调用远程失败",
"393266":"创建flow失败",
"393267":"删除flow失败",
"393268":"更新function template失败",
"393269":"创建function template失败",
"393270":"删除program account失败",
"393272":"读取user module stream失败",
"393273":"解析user module stream失败",
"393280":"创建program account失败",
"393281":"更新program account失败",
"524288":"应用不存在",
"524289":"应用信息不完善",
"524290":"无效的重定向地址",
"524291":"应用配置信息不完善",
"524292":"无效的应用域名",
"524293":"sso服务错误",
"524294":"没有应用访问权限",
"524295":"单点协议配置信息不完善",
"524296":"租户不存在",
"524297":"租户信息不完善",
"524298":"无效的授权请求",
"524299":"implicit模式下必须使用https",
"524300":"无效的code",
"524301":"无效的access token",
"524302":"无效的refresh_token",
"524303":"无效的应用密钥",
"524304":"用户不存在",
"524305":"未开通子账号",
"524306":"未选择子账号",
"12288":"应用已存在",
"12289":"应用配置已存在",
"12290":"应用配置id错误",
"12291":"应用单点协议已存在",
"12292":"应用单点协议id错误",
"12293":"子账号已存在",
"12294":"应用类型错误",
"12295":"应用模板id错误",
"12296":"应用模板值错误",
"12297":"应用名称有误",
"12298":"应用id有误",
"12299":"应用分类有误",
"12300":"应用域名有误",
"12301":"应用重定向地址有误",
"12302":"应用单点协议类型有误",
"12303":"应用单点协议内容有误",
"12304":"应用单点协议数量过多",
"12305":"应用登录方式有误",
"12306":"应用默认登录方式有误",
"12307":"应用注册方式有误",
"12308":"应用默认注册方式有误",
"12309":"应用多因素认证有误",
"12310":"应用身份源有误",
"12311":"应用默认协议有误",
"12312":"应用登录地址有误",
"12313":"应用登出地址有误",
"12314":"应用启用了多个单点协议",
"12315":"应用访问规则有误",
"12316":"应用下存在子账号",
"12317":"用户id有误",
"12318":"子账号名称有误",
"12319":"子账号状态异常",
"12320":"用户名有误",
"12321":"应用属性字段有误",
"12322":"图片有误",
"12323":"图片过大",
"12324":"用户状态异常",
"12325":"租户异常",
"12326":"应用系统扩展字段有误",
"12327":"应用模板名称有误",
"12328":"应用模板可见范围有误",
"12329":"应用模板状态异常",
"12330":"应用模板存在关联应用",
"12331":"图片格式不支持",
"12332":"应用模板类型有误",
"12333":"应用模板参数版本有误",
"12334":"子账号类型有误",
"12335":"不可修改子账号归属",
"12336":"共享账号不可设置归属",
"12337":"子账号id有误",
"12338":"失效时间有误",
"12339":"子账号已过期",
"12340":"域名过短",
"12341":"域名过长",
"12342":"域名前缀与保留域名冲突",
"12343":"域名包含内容有误",
"12344":"域名与保留域名冲突"
};

export default map;
